export default __webpack_public_path__ + "static/media/HomepageCollectCard.f262b144.png";